import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';

import type { Campaign } from '@feathr/blackbox';
import CreativeThumbnail from '@feathr/extender/components/CreativeThumbnail';
import EmailTemplateThumbnail from '@feathr/extender/components/EmailTemplateThumbnail';
import { StoresContext, useLocalUrl } from '@feathr/extender/state';

import TLDR from '../../TLDR';

import * as styles from './CampaignTLDR.css';

import noImg from 'images/no-img.png';

interface IProps {
  campaign?: Campaign;
}

// Show a summary of the Templates and Creatives used in a campaign
function CampaignTLDR({ campaign }: IProps) {
  const localUrl = useLocalUrl();
  const { Creatives } = useContext(StoresContext);
  const creatives = campaign?.isCreativesCampaign
    ? Creatives.list({ filters: { _parent: campaign.id }, pagination: { page_size: 1 } })
    : undefined;

  if (campaign === undefined || campaign.isPending || creatives?.isPending) {
    return <TLDR isLoading={true} />;
  }

  function getCreative() {
    // If pinpoint email campaign, then get template
    if (campaign?.isPinpointCampaign) {
      return <EmailTemplateThumbnail campaign={campaign} />;
    }
    // Otherwise get the creative
    else if (creatives) {
      // Maps over a list of creatives where the parent of the creative is a campaign id
      return creatives.models.map((creative, index) => (
        <CreativeThumbnail className={styles.image} creative={creative.toJS()} key={index} />
      ));
    }
    return noImg;
  }

  return (
    <TLDR
      image={getCreative()}
      isLoading={false}
      link={localUrl(campaign.getItemUrl())}
      rowReverse={true}
    >
      {campaign.name}
    </TLDR>
  );
}

export default observer(CampaignTLDR);
